import { HttpMethod } from '../../components/Common/useFetch';
import { RequestOptions } from '../../components/Common/useRequest';
import useUserOrKaEmployeeRequest from '../../components/Common/useUserOrEmployeeRequest';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface MarkFieldAlyticsExportedRequest {
  number: string;
  notes?: string;
}

const useMarkFieldAlyticsExported = (options?: RequestOptions<void>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrKaEmployeeRequest<MarkFieldAlyticsExportedRequest>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/orders/markExported`, method: HttpMethod.POST },
    options
  );
};

export default useMarkFieldAlyticsExported;
